export default "__VITE_ASSET__59b12b42__"